import { provideRouter } from '@angular/router';
import { AppComponent } from './app/components/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import routes from './app/app-routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { bearerInterceptor } from './app/interceptors/bearer.interceptor';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { DHIG_DATE_FORMATS, DhigDateAdapter } from './app/adapters/dhig-date.adapter';
import { AuthInterceptor } from './app/core/interceptors/htttp.auth.interceptor';
import { InitializeAppService } from './app/core/services/initialize-app.service';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { DateOnlyPipe } from './app/shared/pipes/date-only.pipe';
import { DateService } from './app/shared/services/date.service';

/*@enableCors({
  origin: [
    'http://localhost:4200',
    'https://api.dev.dhig.info',
    'https://api.dhig.info',
    'https://api.staging.dhig.info',
  ],
});*/

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
};

function initializeApp(initializeAppService: InitializeAppService) {
  return () => initializeAppService.initializeApp();
}

bootstrapApplication(AppComponent, {
  providers: [
    DateService,
    provideHttpClient(),
    provideRouter(routes),
    importProvidersFrom(BrowserAnimationsModule),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [InitializeAppService],
      multi: true,
    },
    provideHttpClient(withInterceptors([bearerInterceptor])),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: MAT_DATE_FORMATS, useValue: DHIG_DATE_FORMATS },
    { provide: DateAdapter, useClass: DhigDateAdapter },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: appearance },
    DateOnlyPipe,
  ],
}).catch((err) => console.error(err));
